import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import { useInboundExternalTransferRequest } from '../../../../../../hooks/api/useInboundTransferRequests';
import { useProfilesTabNavigation } from '../../../../../../utils/appNavigationNames';
import LargeAlertPaper from '../../../../../v2BaseComponents/LargeAlertPaper';

const intl = getIntl('inbound-transfer-request-alert-message', {
    header: 'Pending Ownership Transfer',
    content:
        'You have been invited to take ownership of this profile. Please accept the invitation to view this profile.',
    actionText: 'Respond to Request',
});

export type ExternalInboundTransferRequestAlertOwnProps = {};

export type ExternalInboundTransferRequestAlertProps = ExternalInboundTransferRequestAlertOwnProps;

const ExternalInboundTransferRequestAlert: React.FC<ExternalInboundTransferRequestAlertProps> = () => {
    const { navigate } = useProfilesTabNavigation();
    const { hasInboundExternalTransferRequest, inboundExternalTransferRequest } = useInboundExternalTransferRequest();

    if (!hasInboundExternalTransferRequest || !inboundExternalTransferRequest) {
        return null;
    }

    return (
        <LargeAlertPaper
            testID="inbound-external-transfer-request-alert"
            icon="HorizontalArrows2"
            title={intl('header')}
            message={intl('content')}
            actionItems={[
                {
                    testID: 'respond-to-external-transfer-request-button',
                    title: intl('actionText'),
                    onPress: () => {
                        navigate('transfer-request-response', {
                            transferProfileId: inboundExternalTransferRequest?.profile.medicalProfileId,
                            transferRequestId: inboundExternalTransferRequest.medicalProfileOwnershipTransferId,
                        });
                    },
                    icon: 'Settings',
                },
            ]}
        />
    );
};

export default React.memo(ExternalInboundTransferRequestAlert);
